import { createDraftJobPost } from './CreateDraftJobPost';
import { createOnsiteInterviews } from './CreateOnsiteInterview';
import { getCandidateList } from './GetCandidateList';
import { getJobPostDetail } from './GetJobPostDetail';
import { getJobPostings } from './GetJobPostings';
import { getOnsiteInterviewList } from './GetOnsiteInterviewList';
import { getOnsiteInterviewStatusCount } from './GetOnsiteInterviewStatusCount';
import { publishDraftJobPost } from './PublishDraftJobPost';
import { saveJobPostDetail } from './SaveJobPostDetail';
import { updateCandidateStatus } from './UpdateCandidateStatus';

export const PermanentJobsApi = {
  createDraftJobPost,
  createOnsiteInterviews,
  getCandidateList,
  getJobPostDetail,
  getJobPostings,
  getOnsiteInterviewList,
  getOnsiteInterviewStatusCount,
  publishDraftJobPost,
  saveJobPostDetail,
  updateCandidateStatus,
};
